import { memo } from "react";
import {
  truncateContent,
  domainOnly,
  pathOnly,
} from "../../../../utils/formatUtils";

export const Url = memo(({ bookmark }) => {
  if (bookmark?.encrypted) {
    return <small className="d-block text-muted">****************</small>;
  }

  const domain = domainOnly(bookmark.url);
  const path = pathOnly(bookmark.url);
  const displayPath = bookmark.path || path;
  const truncatedPath = truncateContent(displayPath, 60);

  return (
    <div className="bookmark-url d-inline-flex align-items-center mw-100 position-relative text-secondary small mt-1 mt-md-0 bg-white">
      <span className="bookmark-url__domain flex-shrink-0 position-relative z-2 bg-white">
        {bookmark.domain || domain}
      </span>
      <span className="bookmark-url__full text-truncate z-1 position-relative position-md-absolute start-md-0 text-nowrap">
        {truncatedPath}
      </span>
    </div>
  );
});

Url.displayName = 'Url';
